import React from 'react';

import { AccessLinkSiteAdminControlsLoader } from '@confluence/access-links/entry-points/AccessLinkSiteAdminControlsLoader.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminShareableLinksRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		sideNavigationId: string;
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <AccessLinkSiteAdminControlsLoader />;

AdminShareableLinksRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	sideNavigationId: string;
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'siteSettingsAccessLinksScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
